import { z } from 'zod';

/**
 * Canal d'un réseau partenaire — cf. docs/specs/typologie-partenaire.md.
 *
 * - `door_to_door` : vendeurs seuls sur le terrain, chacun son téléphone,
 *   chacun pour soi. Le modèle d'origine de Doorly.
 * - `retail` : boutiques. Des tablettes partagées (bascule par code PIN), un
 *   classement entre collègues, le superviseur crée ses vendeurs. Le réseau
 *   déclare ses **magasins** (`Store`) et le back-office y affecte chacun —
 *   un superviseur (RPV) peut en couvrir plusieurs, et les gros réseaux les
 *   déplacent d'un magasin à l'autre : « un superviseur = un magasin » est
 *   FAUX depuis la réunion du 09/10/2026 (cf. schemas/store.ts).
 *
 * Deux valeurs, pas plus : « on verra si un jour on a une autre typologie,
 * mais ce n'est pas le cas pour l'instant » (réunion du 11/09/2026).
 */
export const PartnerChannelSchema = z.enum(['door_to_door', 'retail']);
export type PartnerChannel = z.infer<typeof PartnerChannelSchema>;

export const PARTNER_CHANNEL_LABEL_FR: Record<PartnerChannel, string> = {
  door_to_door: 'Porte-à-porte',
  retail: 'Magasin',
};

/** Une phrase par canal — la même partout où on le choisit. */
export const PARTNER_CHANNEL_DESCRIPTION_FR: Record<PartnerChannel, string> = {
  door_to_door: 'Vendeurs seuls sur le terrain, chacun avec son téléphone et son compte.',
  retail:
    'Des magasins, des tablettes partagées avec code PIN, un classement entre vendeurs.',
};

/**
 * Le seul point de lecture du canal pour tout ce qui en découle (PIN,
 * classement, fiches du jour). Ne jamais recopier le résultat dans un
 * drapeau : c'est précisément ce que la typologie remplace.
 */
export function isRetail(partner: { channel?: PartnerChannel | null } | null | undefined): boolean {
  return partner?.channel === 'retail';
}
